import React from 'react';
import { useParams } from 'react-router-dom';
import { blogsData } from './BlogsData';
import './BlogPage.css';

const BlogPage = () => {
  const { id } = useParams();
  const blog = blogsData.find(b => b.id === id);

  if (!blog) return <div className="blog-full-page" style={{textAlign: "center"}}>Blog not found.</div>;

  return (
    <div className="blog-full-page">
      <div className="blog-header">
        <div>
          <div className="blog-title">{blog.title}</div>
          <div className="blog-subheading">{blog.subHeading}</div>
          <div className="blog-labels">
            {blog.labels.map(label => (
              <span key={label} className="blog-label">{label}</span>
            ))}
          </div>
        </div>
        <div className="blog-date">{blog.date}</div>
      </div>
      <div className="blog-body" dangerouslySetInnerHTML={{__html: blog.fullContent}} />
    </div>
  );
};

export default BlogPage;
